module.exports = __webpack_public_path__ + "img/av044.41d44b66.png";